import { Injectable } from '@angular/core';
import { ApiService } from './api';

import { UserManager } from './managers/user.manager';

import { Horse } from '../model/horse';
import { Account } from '../model/account';
import { Trade } from '../model/trade';

@Injectable()
export class UserService {
    constructor(private api: ApiService, private userManager: UserManager) {}

    updateUserPassword(id, password) {
        return new Promise((resolve, reject) => {
            this.api
                .putWithAuth(
                this.api.endpoints.users +
                '/updatePassword?id=' +
                id +
                '&password=' +
                password
                )
                .then(data => resolve(data), error => reject(error));
        });
    }

    getUser(userId: number) {
        this.api.getWithAuth(this.api.endpoints.users + '/getAccount?id=' + userId)
        .then(data => {
            if (data) {
                this.userManager.receiveAccount(data as Account);
            }
        }, error => console.error(error));
    }

    getAccount(accountId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.users + '/get?accountId=' + accountId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    updateAccount(user: any) {
        return new Promise((resolve, reject) => {
            this.api
                .putWithAuth(this.api.endpoints.users + '/updateAccount?id=' + user.id, user)
                .then(data => resolve(data), error => reject(error));
        });
    }

    activateAccount(userId: number, organizationId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .putWithAuth(this.api.endpoints.users + '/activateAccount?id=' + userId + '&organizationId=' + organizationId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    updateStaffAccounts(users: any) {
        return new Promise((resolve, reject) => {
            this.api
                .putWithAuth(this.api.endpoints.users + '/updateStaffAccounts', users)
                .then(data => resolve(data), error => reject(error));
        });
    }

    addUser(user: any) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithoutAuth(this.api.endpoints.users + '/createFromApp', user)
                .then(data => resolve(data), error => reject(error));
        });
    }

    addUserFromStaff(user: any) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithoutAuth(this.api.endpoints.users + '/createFromStaff', user)
                .then(data => resolve(data), error => reject(error));
        });
    }

    updateUserRole(account, organizationId, roleId) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.users + '/updateUserRole?organizationId=' + organizationId + '&roleId=' + roleId, account)
                .then(data => resolve(data), error => reject(error));
        });
    }

    getHorses(accountId) {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.users + '/getHorses' + '?accountId=' + accountId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    addHorse(accountId : number, horse: Horse) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.users + '/addHorse' + '?accountId=' + accountId, horse)
                .then(data => resolve(data), error => reject(error));
        });
    }

    addOrgPermsToUsers(accounts: Account[], orgId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.users + '/addOrgPermsToUsers' + '?organizationId=' + orgId, accounts)
                .then(data => resolve(data), error => reject(error));
        });
    }

    createNotification(accountId : number, rodeoEventId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.users + '/createNotification' + '?accountId=' + accountId + '&rodeoEventId=' + rodeoEventId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    deleteNotification(accountId : number, rodeoEventId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.users + '/deleteNotification' + '?accountId=' + accountId + '&rodeoEventId=' + rodeoEventId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    createTradeRequest(accountId: number, requestorRunId: number, targetRunId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.users + '/createTradeRequest' + '?accountId=' + accountId + '&requestorRunId=' + requestorRunId + '&targetRunId=' + targetRunId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    confirmTrade(accountId: number, trade: Trade) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.users + '/confirmTrade' + '?accountId=' + accountId, trade)
                .then(data => resolve(data), error => reject(error));
        });
    }

    cancelTrade(accountId: number, trade: Trade) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.users + '/cancelTrade' + '?accountId=' + accountId, trade)
                .then(data => resolve(data), error => reject(error));
        });
    }

    markNotificationsRead(accountId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.users + '/markNotificationsRead' + '?accountId=' + accountId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    getUserTrades(accountId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.users + '/getUserTrades' + '?accountId=' + accountId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    mergeAccounts(mergedUser, destinationAccountId, sourceAccountId) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.users + '/MigrateAccount?' + 'destinationAccountId=' + destinationAccountId + '&sourceAccountId=' + sourceAccountId + '&markSourceInactive=true', mergedUser)
                .then(data => resolve(data), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/user.service.ts